import { combineReducers } from 'redux'
import { trustSlice } from 'Pages/ibro/settings/store/slice'

export * from './slice'
export * from './saga'
export * from './selector'

export const settings = combineReducers({
	[trustSlice.name]: trustSlice.reducer,
})
